import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import env from '../env.json'

const reactPlugin = new ReactPlugin()
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: env.appInsightsKey,
    EnableRequestTrackingTelemetryModule: false,
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    extensions: [reactPlugin],
  },
})

appInsights.loadAppInsights()
